// Función para obtener vehículos por tipo de taxonomía
document.addEventListener('DOMContentLoaded', () => {
    const tipoOptions = document.querySelectorAll('.tipo-option');
    const modelDropdownContainer = Array.from(
        document.querySelectorAll('.custom-dropdown')
    ).find((dropdown) => {
        const placeholder = dropdown.querySelector('.dropdown-placeholder');
        return placeholder && placeholder.textContent.includes('Modelo');
    });

    const modelDropdown = modelDropdownContainer
        ? modelDropdownContainer.querySelector('.dropdown-options ul')
        : null;

    const nonce = window.ajax_object ? window.ajax_object.nonce : '';

    tipoOptions.forEach((option) => {
        option.addEventListener('click', () => {
            const termId = option.getAttribute('data-value');

            if (!modelDropdown) {
                console.error('No se encontró el dropdown de modelo');
                return;
            }

            const modelPlaceholder = modelDropdownContainer.querySelector(
                '.dropdown-placeholder'
            );
            if (modelPlaceholder) {
                modelPlaceholder.textContent = 'Modelo';
                modelPlaceholder.classList.remove('text-gray-900');
                modelPlaceholder.classList.add('text-gray-500');
            }

            // Verificar estado del botón después de seleccionar tipo
            checkButtonState();

            modelDropdown.innerHTML =
                '<li class="dropdown-option px-4 py-2 text-gray-400">Cargando...</li>';

            // Mostrar spinner
            const spinner = document.getElementById('spinner-comparative');
            if (spinner) {
                spinner.classList.remove('hidden');
                spinner.classList.add('flex');
            }

            fetch(window.ajax_object.ajax_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    action: 'get_vehicles_by_type',
                    term_id: termId,
                    nonce: nonce,
                }),
            })
                .then((response) => response.json())
                .then((data) => {
                    // Ocultar spinner
                    const spinner = document.getElementById('spinner-comparative');
                    if (spinner) {
                        spinner.classList.add('hidden');
                        spinner.classList.remove('flex');
                    }

                    if (data.success) {
                        modelDropdown.innerHTML = '';

                        data.data.forEach((vehicle) => {
                            const li = document.createElement('li');
                            li.className =
                                'dropdown-option model-option px-4 py-2 hover:bg-gray-100 text-[#565656] text-[1.6rem] cursor-pointer transition-colors';
                            li.setAttribute('data-value', vehicle.id);
                            li.textContent = vehicle.name;
                            modelDropdown.appendChild(li);
                        });

                        initializeModelOptions();

                        initializeDropdownForNewOptions();
                    } else {
                        console.error('Error al cargar vehículos:', data);
                    }
                })
                .catch((error) => {
                    // Ocultar spinner en caso de error
                    const spinner = document.getElementById('spinner-comparative');
                    if (spinner) {
                        spinner.classList.add('hidden');
                        spinner.classList.remove('flex');
                    }
                    
                    console.error('Error en la llamada AJAX:', error);
                    modelDropdown.innerHTML =
                        '<li class="dropdown-option px-4 py-2 text-red-500">Error al cargar</li>';
                });
        });
    });

    function initializeModelOptions() {
        const modelOptions = document.querySelectorAll('.model-option');

        modelOptions.forEach((option) => {
            option.addEventListener('click', () => {
                const value = option.getAttribute('data-value');
            });
        });
    }

    function initializeDropdownForNewOptions() {
        const modelOptions = document.querySelectorAll('.model-option');
        const placeholder = modelDropdownContainer.querySelector(
            '.dropdown-placeholder'
        );
        const options =
            modelDropdownContainer.querySelector('.dropdown-options');
        const chevron = modelDropdownContainer.querySelector(
            '.fas.fa-chevron-down'
        );

        modelOptions.forEach((option) => {
            option.addEventListener('click', (e) => {
                e.stopPropagation();

                const value = option.getAttribute('data-value');
                const text = option.textContent;

                placeholder.textContent = text;
                placeholder.classList.remove('text-gray-500');
                placeholder.classList.add('text-gray-900');

                modelDropdownContainer.dataset.selectedValue = value;

                options.classList.add('hidden');
                chevron.classList.remove('rotate-180');

                // Verificar estado del botón después de seleccionar modelo
                checkButtonState();

                modelDropdownContainer.dispatchEvent(
                    new CustomEvent('dropdownChange', {
                        detail: { value, text },
                    })
                );
            });
        });
    }

    let vehicleCount = 0;
    const maxVehicles = 3;

    function toggleVehicleTitles() {
        const vehicleTitles = document.querySelector('.vehicle-titles');
        if (vehicleCount > 0) {
            vehicleTitles.classList.remove('hidden');
        } else {
            vehicleTitles.classList.add('hidden');
        }
    }

    function toggleAddButton() {
        const addButton = document.querySelector('button span');
        const addButtonParent =
            addButton && addButton.textContent.includes('Agregar')
                ? addButton.parentElement
                : null;

        if (addButtonParent) {
            if (vehicleCount >= maxVehicles) {
                addButtonParent.disabled = true;
                addButtonParent.classList.add(
                    'opacity-50',
                    'cursor-not-allowed'
                );
            } else {
                addButtonParent.disabled = false;
                addButtonParent.classList.remove(
                    'opacity-50',
                    'cursor-not-allowed'
                );
            }
        }
    }

    function createVehicleHTML(vehicleData) {
        const specsHTML =
            vehicleData.comparative_table && vehicleData.comparative_table.body
                ? vehicleData.comparative_table.body
                      .map(
                          (spec, index) => `
                <div class="px-6 h-[7.5rem] flex items-center text-black text-[1.4rem] ${
                    index % 2 === 0 ? 'bg-[#EFEFF4]' : 'bg-white'
                } border-[#DADADA]">
                    ${spec[1].c}
                </div>
            `
                      )
                      .join('')
                : '';

        // Generar HTML de colores
        const colorsHTML = vehicleData.colors && vehicleData.colors.length > 0 
            ? `<div class="py-4 flex justify-center items-center gap-2 [&_.color-active]:ring-white [&_.color-active]:ring-2 [&_.color-active]:drop-shadow-md">
                 ${vehicleData.colors.map((color, index) => 
                   `<div class="w-[1.7rem] h-[1.7rem] duration-200 ring-2 ring-transparent rounded-full cursor-pointer handleDynamicImg ${index === 0 ? 'color-active' : ''}" 
                         data-img="${color.image.url}" 
                         style="background-color: ${color.color};"></div>`
                 ).join('')}
               </div>`
            : '';

        return `
            <div class="w-[33%]" data-vehicle-id="${vehicleData.id}">
                <div class="px-4 pb-8">
                    <div class="border border-(--secondary-v2-color)">
                        <div class="py-7 min-h-[10rem] flex items-center justify-center text-center border-b border-(--secondary-v2-color) relative" title="${vehicleData.name}">
                            <p class="uppercase font-(family-name:--font-russo) text-[2.1rem] px-16 line-clamp-2">${
                                vehicleData.name
                            }</p>
                            <button class="remove-vehicle absolute top-[50%] -mt-[10px] right-5 text-[#B4B4B4] cursor-pointer" data-vehicle-id="${
                                vehicleData.id
                            }">
                                <i class="fa-solid fa-xmark text-3xl"></i>
                            </button>
                        </div>

                        <div class="h-[27.1rem] [&_img]:w-full [&_img]:h-full [&_img]:object-contain p-2 dynamicSrcImg">
                            ${
                                vehicleData.colors && vehicleData.colors.length > 0
                                    ? `<img src="${vehicleData.colors[0].image.url}" alt="${vehicleData.title}" class="fadeIn">`
                                    : vehicleData.thumbnail
                                    ? `<img src="${vehicleData.thumbnail}" alt="${vehicleData.title}" class="fadeIn">`
                                    : ''
                            }
                        </div>

                        ${colorsHTML}

                        <div class="max-w-[26.5rem] m-auto px-8">
                            <a href="#" target="_self" class="w-full py-4 block border border-(--secondary-color) font-bold px-8 transform -skew-x-12 text-center duration-300 font-(family-name:--font-russo) tracking-widest bg-(--secondary-color) text-white hover:bg-(--primary-color) hover:border-(--primary-color)">
                                <span class="block transform skew-x-12 text-[1.4rem]">Cotizar</span>
                            </a>
                        </div>
                    </div>
                </div>
                ${specsHTML}
            </div>
        `;
    }

    function addVehicle(vehicleData) {
        if (vehicleCount >= maxVehicles) {
            console.log('Máximo de vehículos alcanzado');
            return;
        }

        const existingVehicle = document.querySelector(
            `[data-vehicle-id="${vehicleData.id}"]`
        );
        if (existingVehicle) {
            console.log('Este vehículo ya está agregado');
            return;
        }

        const appendContainer = document.querySelector('.append-vehicles');
        const vehicleHTML = createVehicleHTML(vehicleData);
        appendContainer.insertAdjacentHTML('beforeend', vehicleHTML);

        vehicleCount++;
        toggleVehicleTitles();
        toggleAddButton();

        if (vehicleCount === 1) {
            const collapseContainer = document.querySelector(
                '.collapse-table-comparative'
            );
            if (collapseContainer && window.initializeCollapseTable) {
                window.initializeCollapseTable(collapseContainer);
            }
        }

        const removeButton = document.querySelector(
            `[data-vehicle-id="${vehicleData.id}"] .remove-vehicle`
        );
        if (removeButton) {
            removeButton.addEventListener('click', () =>
                removeVehicle(vehicleData.id)
            );
        }

        // Inicializar funcionalidad de colores para este vehículo
        initializeVehicleColors(vehicleData.id);
    }

    function removeVehicle(vehicleId) {
        const vehicleElement = document.querySelector(
            `[data-vehicle-id="${vehicleId}"]`
        );
        if (vehicleElement) {
            vehicleElement.remove();
            vehicleCount--;
            toggleVehicleTitles();
            toggleAddButton();

            if (vehicleCount === 0) {
                const collapseButton = document.querySelector('.cta-collapse');
                if (collapseButton) {
                    collapseButton.style.display = 'none';
                }
                const buttonContainer = document.querySelector('.cta-see-more');
                if (buttonContainer) {
                    buttonContainer.classList.add('hidden');
                }

                const collapseContainer = document.querySelector(
                    '.collapse-table-comparative'
                );
                if (collapseContainer) {
                    collapseContainer.removeAttribute('style');
                    console.log('Contenedor reseteado a estado original');
                }
            }
        }
    }

    // Función para inicializar la funcionalidad de colores de un vehículo
    function initializeVehicleColors(vehicleId) {
        const vehicleElement = document.querySelector(`[data-vehicle-id="${vehicleId}"]`);
        if (!vehicleElement) return;

        const colorCircles = vehicleElement.querySelectorAll('.handleDynamicImg');
        const vehicleImage = vehicleElement.querySelector('.dynamicSrcImg img');

        colorCircles.forEach((colorCircle) => {
            colorCircle.addEventListener('click', function () {
                const newImageUrl = this.getAttribute('data-img');
                
                if (vehicleImage && newImageUrl) {
                    // Quitar color-active de todos los hermanos del mismo grupo
                    const siblings = this.parentElement.querySelectorAll('.handleDynamicImg');
                    siblings.forEach(sibling => {
                        sibling.classList.remove('color-active');
                    });

                    // Agregar color-active al que se hizo clic
                    this.classList.add('color-active');

                    // Cambiar la imagen
                    vehicleImage.classList.remove('fadeIn');
                    vehicleImage.offsetHeight; // Force reflow
                    vehicleImage.src = newImageUrl;
                    vehicleImage.classList.add('fadeIn');
                }
            });
        });
    }

    const addButton = document.querySelector('button span');
    const addButtonParent =
        addButton && addButton.textContent.includes('Agregar')
            ? addButton.parentElement
            : null;

    // Función para verificar si el botón debe estar habilitado
    function checkButtonState() {
        if (!addButtonParent) return;
        
        // Buscar los placeholders usando los contenedores que ya tenemos
        const tipoPlaceholder = document.querySelector('.custom-dropdown:first-of-type .dropdown-placeholder');
        const modeloPlaceholder = modelDropdownContainer ? modelDropdownContainer.querySelector('.dropdown-placeholder') : null;
        
        // Debug
        // console.log('Tipo placeholder:', tipoPlaceholder ? tipoPlaceholder.textContent : 'No encontrado');
        // console.log('Modelo placeholder:', modeloPlaceholder ? modeloPlaceholder.textContent : 'No encontrado');
        
        // Verificar si ambos selects tienen valores (no son placeholders)
        const tipoHasValue = tipoPlaceholder && tipoPlaceholder.textContent !== 'Tipo de moto';
        const modeloHasValue = modeloPlaceholder && modeloPlaceholder.textContent !== 'Modelo';
        
        // console.log('Tipo tiene valor:', tipoHasValue);
        // console.log('Modelo tiene valor:', modeloHasValue);
        
        // Habilitar/deshabilitar botón
        if (tipoHasValue && modeloHasValue) {
            addButtonParent.disabled = false;
            // console.log('Botón habilitado');
        } else {
            addButtonParent.disabled = true;
            // console.log('Botón deshabilitado');
        }
    }

    // Verificar estado inicial del botón
    checkButtonState();
    if (addButtonParent) {
        addButtonParent.addEventListener('click', () => {
            if (vehicleCount >= maxVehicles) {
                console.log('Máximo de vehículos alcanzado');
                return;
            }

            const modelPlaceholder = modelDropdownContainer.querySelector(
                '.dropdown-placeholder'
            );
            if (
                !modelPlaceholder ||
                modelPlaceholder.textContent === 'Modelo'
            ) {
                console.error('No hay modelo seleccionado');
                return;
            }

            const selectedModelOption = Array.from(
                document.querySelectorAll('.model-option')
            ).find(
                (option) => option.textContent === modelPlaceholder.textContent
            );

            if (!selectedModelOption) {
                console.error('No se encontró la opción seleccionada');
                return;
            }

            const vehicleId = selectedModelOption.getAttribute('data-value');

            const existingVehicle = document.querySelector(
                `[data-vehicle-id="${vehicleId}"]`
            );
            if (existingVehicle) {
                console.log('Este vehículo ya está agregado');
                return;
            }

            // Mostrar spinner
            const spinner = document.getElementById('spinner-comparative');
            if (spinner) {
                spinner.classList.remove('hidden');
            }

            fetch(window.ajax_object.ajax_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    action: 'get_vehicle_by_id',
                    vehicle_id: vehicleId,
                    nonce: nonce,
                }),
            })
                .then((response) => response.json())
                .then((data) => {
                    // Ocultar spinner
                    const spinner = document.getElementById('spinner-comparative');
                    if (spinner) {
                        spinner.classList.add('hidden');
                    }

                    if (data.success) {
                        console.log('Vehículo completo:', data.data);
                        addVehicle(data.data);
                        clearModelDropdown();
                    } else {
                        console.error('Error al obtener vehículo:', data);
                    }
                })
                .catch((error) => {
                    // Ocultar spinner en caso de error
                    const spinner = document.getElementById('spinner-comparative');
                    if (spinner) {
                        spinner.classList.add('hidden');
                    }
                    
                    console.error('Error en la llamada AJAX:', error);
                });
        });
    }

    function clearModelDropdown() {
        const modelPlaceholder = modelDropdownContainer.querySelector(
            '.dropdown-placeholder'
        );
        if (modelPlaceholder) {
            modelPlaceholder.textContent = 'Modelo';
            modelPlaceholder.classList.remove('text-gray-900');
            modelPlaceholder.classList.add('text-gray-500');
        }
    }


    document.addEventListener('click', function(e) {
        if (e.target.closest('.compare-btn')) {
            const btn = e.target.closest('.compare-btn');
            const vehicleId = btn.getAttribute('data-vehicle-id');
            const vehicleTipo = btn.getAttribute('data-vehicle-tipo');
            
            if (vehicleId && vehicleTipo) {
                localStorage.setItem('preselectedVehicle', JSON.stringify({
                    vehicleId: vehicleId,
                    tipoId: vehicleTipo
                }));
            }
        }
    });

    const preselectedData = localStorage.getItem('preselectedVehicle');
    if (preselectedData) {
        try {
            const data = JSON.parse(preselectedData);
            const tipoId = data.tipoId;
            const vehicleId = data.vehicleId;
            
            const tipoOption = document.querySelector(`[data-value="${tipoId}"]`);
            if (tipoOption) {
                tipoOption.click();
                
                const checkForModel = () => {
                    const modelOption = document.querySelector(`[data-value="${vehicleId}"]`);
                    if (modelOption) {
                        modelOption.click();
                        
                        const addButton = document.querySelector('button span');
                        if (addButton && addButton.textContent.includes('Agregar')) {
                            addButton.parentElement.click();
                        }
                        
                        localStorage.removeItem('preselectedVehicle');
                    } else {
                        setTimeout(checkForModel, 100);
                    }
                };
                
                setTimeout(checkForModel, 200);
            }
        } catch (e) {
            console.error('Error parsing preselected vehicle data:', e);
        }
    }
});
